import { useStaticQuery, graphql } from 'gatsby';

const useForm = () => {
  const data = useStaticQuery(graphql`
    query useFormQuery {
      sanityForm {
        addFormToAllPages
        isGradient
        headlineColor {
          color
        }
        headline
        ctaButtonLabel
        bgImg {
          alt
          asset {
            gatsbyImageData(placeholder: BLURRED, formats: WEBP)
          }
        }
        formFields {
          label
          options
          placeholder
          required
          type
        }
      }
    }
  `);

  const form = data.sanityForm;

  return form;
};

export { useForm };
